var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-template',[_c('v-container',{attrs:{"align":"center","fill-height":""}},[_c('v-row',{attrs:{"justify":"center","align":"center","align-content":"center"}},[_c('login-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }